import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-navigation-logged-out-home-section-services',
  template: `
    <app-navigation-menu-list
      [list]="servicesList"
      [marginBottomTablet]="'xxsmall'"
    >
    </app-navigation-menu-list>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLoggedOutHomeSectionServicesComponent {
  servicesList = [
    {
      linkDescription: $localize`Preferred Freelancer Program`,
      linkUrl: '/preferred-freelancer-program',
    },
    {
      linkDescription: $localize`Verified by Freelancer`,
      linkUrl: '/verified',
    },
    {
      linkDescription: $localize`Project management`,
      linkUrl: '/project-management',
    },
    {
      linkDescription: $localize`Recruiter`,
      linkUrl: '/recruiter',
    },
    {
      linkDescription: $localize`Memberships`,
      linkUrl: '/membership',
    },
  ];
}
